import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTCLI_LoadingXX } from './LoadingStateWrapper.messages.json';

interface Props {
  className?: string;
}

const LoadingStateWrapper: React.FC<React.PropsWithChildren<Props>> = ({ children, className }) => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div role="status" aria-label={formatMessage(TXTCLI_LoadingXX)} className={className}>
      {children}
    </div>
  );
};

export default LoadingStateWrapper;
